import './UserNotifications.scss';

import {Badge} from 'antd';
import React from 'react';

import {PROFILE_PAGE_NOTIFICATION_TAB} from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import {IconNotification} from '../Icons';

const UserNotifications = ({onClick, count = 0, isOpen = false}) => {
    const title = getLocalizedStrings()[PROFILE_PAGE_NOTIFICATION_TAB];

    return (
        <>
            <div className='hidden md:block'>
                <div className='hover:cursor-pointer h-6' onClick={onClick}>
                    <Badge
                        count={count}
                        overflowCount={999}
                        size='small'
                        offset={[8, -2]}
                        style={{
                            backgroundColor: 'var(--color-red-status)',
                            color: 'var(--color-white)',
                            boxShadow: '0 0 0 2px var(--color-white)',
                            fontWeight: '500',
                            padding: '0 6px',
                        }}
                    >
                        <IconNotification />
                    </Badge>
                </div>
            </div>
            <button
                type='button'
                className='header-notifications-button'
                onClick={onClick}
                aria-label={count > 0 ? `${title} (${count})` : title}
                aria-expanded={isOpen}
                aria-controls='notifications-panel'
                aria-haspopup='dialog'
            >
                <IconNotification aria-hidden />
                {count > 0 && (
                    <span className='header-notifications-count' aria-hidden>
                        {count > 99 ? '99+' : count}
                    </span>
                )}
            </button>
        </>
    );
};

export default UserNotifications;
